// Usage: Load all javascript components on the element this controller is
// attached to. Useful when you need a particular component loaded when the dom
// changes and isn't triggered by a page load event (ex. turbo stream updates).
//
// Example:
//
// When turbo replaces the current `#form` element on the dom, the Components
// controller will connect and load all javascript components for that new node.
// <turbo-stream action="replace" target="form">
//   <template>
//     <form id="form" data-controller="components">
//       ...
//     </form>
//   </template>
// </turbo-stream>
import { Controller } from "@hotwired/stimulus"
import Components from "../components";

export default class extends Controller {
  connect() {
    Components.collection.loadFragment(this.element);
  }
}
